import { useState, useRef } from "react";

export default function PreviewableImage({ src, alt }) {
    const [showPreview, setShowPreview] = useState(false);
    const timerRef = useRef(null);
  
    const handleMouseDown = () => {
      timerRef.current = setTimeout(() => {
        setShowPreview(true); // long press detected
      }, 500); // 500ms press
    };
  
    const cancelLongPress = () => {
      clearTimeout(timerRef.current);
    };
  
    return (
      <>
        <img
          src={src}
          alt={alt}
          className="card-image"
          onMouseDown={handleMouseDown}
          onMouseUp={cancelLongPress}
          onMouseLeave={cancelLongPress}
          onTouchStart={handleMouseDown}
          onTouchEnd={cancelLongPress}
        />
  
        {showPreview && (
          <div className="image-preview-overlay" onClick={() => setShowPreview(false)}>
            <img src={src} alt={alt} className="image-preview-big" />
          </div>
        )}
      </>
    );
  }